var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.34749L2.25 8.34749L2.25 14.4186L8.25 14.4186L8.25 8.34749ZM21.75 8.34749L15.75 8.34749L15.75 14.4186L21.75 14.4186L21.75 8.34749ZM6.525 -0.000336625L3.525 6.07081L10.5 6.07081L10.5 16.6953L0 16.6953L9.55361e-07 5.76725L2.85 -0.000336946L6.525 -0.000336625ZM20.025 -0.000335445L17.025 6.07081L24 6.07081L24 16.6953L13.5 16.6953L13.5 5.76725L16.35 -0.000335766L20.025 -0.000335445Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.420fd3e4a294512b74bf5e3fcd65bf30.svg";
export { ForwardRef as ReactComponent };